import { createSelector } from '@reduxjs/toolkit';
import { isEmpty, omit } from 'lodash';
import { getFromImmutableState } from '../../../../utils/immutableUtils';
import { getIsWhitelabel } from './view';

const _getBreadcrumbs = (state) => state.get('breadcrumbs');

export const getBreadcrumbsList = getFromImmutableState(_getBreadcrumbs);
export const getBreadcrumbs = createSelector(
  [getBreadcrumbsList, getIsWhitelabel],
  (items, isWhitelabel) => {
    if (isEmpty(items)) {
      return null;
    }

    if (isWhitelabel) {
      return items.map((item) => omit(item, ['link']));
    }

    return items;
  },
);
